<div class="container mt-5">

    <h4>LISTADO DE CLIENTES</h4>

    <form action="">
        <div class="form-group">
            <input type="text" class="form-control" placeholder="Busque un cliente">
        </div>
    </form>

    <div class="row">
        <div class="col-sm-3" *ngFor="let cliente of clientes">
            <div class="card">
                <img class="card-img-top imgCliente" [src]="cliente.imgUrl" alt="Card image cap">
                <div class="card-body">
                    <p>{{cliente.id}}</p>
                    <h5 class="card-title">{{cliente.nombre}} {{cliente.apellido}}</h5>
                    <a [routerLink]="['/agregar-cliente/', cliente.id]" class="card-link">Editar</a>
                    <a href="#" class="card-link text-danger">Desactivar</a>
                </div>
            </div>
        </div>
    </div>
</div>